export const homeAway = {
    H: '(H)',
    A: '(A)',
};
